import React from "react";
import useFolderImages from "../hooks/useFolderImages";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { BODY_STYLE, PAGE_TITLE_STYLE } from "../edit/textStyles";

function DiscipleshipPage() {
  const { urls, loading } = useFolderImages("discipleship_images");
  const imageUrl = urls[0];
  return (
    <div className="main-content" style={{ maxWidth: 1000, margin: "0 auto", padding: 24 }}>
      <EditableText id="discipleship.title" defaultContent="门徒建造/小组团契" defaultStyle={PAGE_TITLE_STYLE} />
      <h1 style={{ textAlign: "center", position: "absolute", left: "-9999px" }}>门徒建造/小组团契</h1>
      <section style={{ margin: "32px 0" }}>
        <div
          style={{
            background: "#e0f7fa",
            borderRadius: 10,
            padding: "24px 16px",
            textAlign: "center",
          }}
        >
          <EditableText
            id="discipleship.verse"
            defaultContent={"我们这许多人在基督里成为一身，\n互相联络做肢体，也是如此。\n\n- 罗马书12:5"}
            defaultStyle={{ textAlign: "center", fontWeight: 600, fontSize: "1.2em", color: "#333" }}
          />
        </div>
      </section>
      <hr style={{ margin: "32px 0" }} />
      <div style={{ display: "flex", flexWrap: "wrap", gap: 32, alignItems: "flex-start" }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <EditableText
            id="discipleship.p1"
            defaultContent="在生命河教会，我们委身于基督的大使命：在全世界建立主的门徒。我们成人事工的重点是帮助每个人在神的话语与圣灵的能力中成长。我们同时也致力于建立一个强大的同工团队来实现这个目标，因为我们认识到，只有当我们在基督里合一时，我们的工作才能有果效。成人事工的内容包括：接触还未认识耶稣的人，向他们传福音，教导圣经，为有需要的人祷告，以及装备信徒来事奉神。成人事工的最终目标是改变人成为委身基督的门徒。"
            defaultStyle={BODY_STYLE}
          />
          <EditableText
            id="discipleship.p2"
            defaultContent="在生命河教会，你可以通过大组聚会与小组团契参与我们的成人事工。"
            defaultStyle={BODY_STYLE}
          />
          <div style={{ margin: "24px 0" }}>
            <EditableText
              id="discipleship.large-group"
              defaultContent="大组聚会：每周五晚6:00 pm – 8:45 pm的查经聚会。目前我们有英语查经班与中文查经班。大组聚会使我们有更多的机会去接触和服事想要认识基督的人们。"
              defaultStyle={{ marginBottom: "12px" }}
            />
            <EditableText
              id="discipleship.small-group"
              defaultContent="小组团契：我们有一对一门训小组与一对多门训小组。小组团契会给你更多的机会在基督里成长并与弟兄姐妹们在基督里建立亲密的个人关系。各个小组的时间安排会根据小组成员的日程有所调整。"
            />
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 240, textAlign: "center" }}>
          {!loading && imageUrl && (
            <img src={imageUrl} alt="团契聚会" style={{ maxWidth: "100%", borderRadius: 12, boxShadow: "0 2px 12px #0001" }} />
          )}
        </div>
      </div>
      <PageCopyright pageId="discipleship" />
      <section style={{ margin: "40px 0 0 0", background: "#e0f7fa", borderRadius: 10, padding: 24, textAlign: "center" }}>
        <EditableText
          id="discipleship.cta"
          defaultContent="想更多了解耶稣， 或者加入我们的事工团队，请用下面的链接联系我们！"
          defaultStyle={{ fontWeight: 600, fontSize: "1.1em", marginBottom: "16px", textAlign: "center" }}
        />
        <a
          href="https://goo.gl/forms/0DQFTu98B3857Vpx1"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "#0693e3",
            color: "#fff",
            padding: "14px 36px",
            borderRadius: 8,
            textDecoration: "none",
            fontWeight: 700,
            fontSize: "1.1em",
          }}
        >
          <EditableText
            id="discipleship.serve-btn"
            as="span"
            defaultContent="服侍主"
            defaultStyle={{ color: "#fff", fontWeight: 700, fontSize: "1.1em" }}
          />
        </a>
      </section>
    </div>
  );
}

export default DiscipleshipPage;
